import { render, staticRenderFns } from "./SuggestedRoutes.vue?vue&type=template&id=1e0b2949"
import script from "./SuggestedRoutes.vue?vue&type=script&lang=js"
export * from "./SuggestedRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports